module.exports = __webpack_public_path__ + "3b87f9d3e23c5ca25787ccc1337a5be6.png";